// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__Sd1F9","navText":"Navbar_navText__oR6ng","navLogo":"Navbar_navLogo__y9N7R","imgLogo":"Navbar_imgLogo__3MbAQ"};